import { urls } from 'shared/urls';

type ImportFunction = () => Promise<unknown>;

export const routeImportMap: Record<string, ImportFunction> = {
  // Home
  [urls.reporting.url()]: () => import('views/pages/HomePage'),

  // Activity
  [urls.allUsers.url()]: () => import('views/pages/AllUsersPage'),
  [urls.userInformation.url()]: () => import('views/pages/UserInformationPage'),
  [urls.orders.url()]: () => import('views/pages/OrdersPage'),
  [urls.orderInformation.url()]: () => import('views/pages/OrderInformationPage'),
  [urls.orderCreate.url()]: () => import('views/pages/CreateOrderPage'),
  [urls.ordersUpload.url()]: () => import('views/pages/BatchOrdersPage'),
  [urls.tasks.url()]: () => import('views/pages/TasksPage'),
  [urls.coverage.url()]: () => import('views/pages/CoveragePage'),

  // Development
  [urls.keys.url()]: () => import('views/account/AccountView/Keys'),
  [urls.generateKeys.url()]: () => import('views/account/AccountView/GenerateKeys'),
  [urls.platforms.url()]: () => import('views/pages/PlatformsPage'),
  [urls.platformKeys.url()]: () => import('views/pages/ExternalIntegrationPage'),
  [urls.logs.url()]: () => import('views/pages/LogsPage'),
  [urls.webhooks.url()]: () => import('views/pages/WebhooksView'),
  [urls.createWebhook.url()]: () => import('views/pages/WebhookView'),
  [urls.editWebhook.url()]: () => import('views/pages/WebhookView'),
  [urls.systemStatus.url()]: () => import('views/pages/SystemStatusPage'),

  // Customization
  [urls.branding.url()]: () => import('views/pages/BrandingCustomizationPage'),
  [urls.templates.url()]: () => import('views/pages/TemplatesPage'),
  [urls.templateCreate.url()]: () => import('views/pages/TemplateCreatePage'),
  [urls.templateEdit.url()]: () => import('views/pages/TemplateEditPage'),
  [urls.fieldsCustomization.url()]: () => import('views/pages/FieldsCustomizationPage'),
  [urls.customSettings.url()]: () => import('views/pages/CustomSettingsPage'),
  [urls.twilioIntegration.url()]: () => import('views/pages/TwilioIntegrationPage'),
  [urls.marketplace.url()]: () => import('views/pages/MarketplacePage'),
  [urls.externalIntegration.url()]: () => import('views/pages/ExternalIntegrationPage'),

  // Billing
  [urls.subscriptions.url()]: () => import('views/pages/SubscriptionsPage'),
  [urls.invoices.url()]: () => import('views/pages/InvoicesPage'),
  [urls.billingUsage.url()]: () => import('views/pages/BillingUsagePage'),
  [urls.creditLedger.url()]: () => import('views/pages/CreditLedgerPage'),
  [urls.monthlyReport.url()]: () => import('views/pages/MonthlyReportPage'),
  [urls.subscriptionFlow.url()]: () => import('views/pages/SubscriptionFlowPage'),

  // Settings
  [urls.company.url()]: () => import('views/pages/CompanyPage'),
  ...(urls.team.parameterUrl ? { [urls.team.parameterUrl()]: () => import('views/pages/TeamPage') } : {}),
  [urls.addMember.url()]: () => import('views/pages/AddMemberPage'),
  [urls.editMember.url()]: () => import('views/pages/EditMemberPage'),
  [urls.profile.url()]: () => import('views/pages/ProfileView'),
  [urls.notifications.url()]: () => import('views/pages/NotificationsPage'),

  // Performance
  [urls.performance.url()]: () => import('views/pages/PerformanceReportsPage'),
  [urls.managers.url()]: () => import('views/pages/TeamPerformancePage'),

  // Emulator
  [urls.emulator.url()]: () => import('views/pages/EmulatorView'),
};
